// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="empowering-veterans-to-take-control-of-their-data-and-put-it-to-work.">Empowering Veterans to take control of their data and put it to work.</h2>
    </div>
  );
};

export default MarkdownComponent;
